import { useEffect, useRef, useCallback } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";

import Grain from "@/components/Grain";
import { Navigation } from "@/components/Navigation";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    lenisRef.current = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const handleNavigate = useCallback((href) => {
    const el = document.querySelector(href);
    if (el && lenisRef.current) {
      lenisRef.current.scrollTo(el, { offset: -20, duration: 1.4 });
    } else if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }, []);

  return (
    <div className="relative min-h-screen bg-eggshell text-ink">
      <Grain />
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#E6DAC0",
            border: "1px solid rgba(176,132,32,0.4)",
            color: "#2B2519",
          },
        }}
      />
      <Navigation onNavigate={handleNavigate} />
      <main>
        <Hero onNavigate={handleNavigate} />
        <Marquee />
        <About />
        <Gallery />
        <Contact />
      </main>
      <Footer onNavigate={handleNavigate} />
    </div>
  );
}

export default App;
